export enum EFeedbackType {
  GENERAL_APPLICATION = "GENERAL_APPLICATION",
  USER_LOGIN = "USER_LOGIN",
  USER_REGISTRATION = "USER_REGISTRATION",
  DEVICES = "DEVICES",
  SMART_CONTROLLER = "SMART_CONTROLLER",
  SEMI_AUTOMATED_SCHEDULING = "SEMI_AUTOMATED_SCHEDULING",
  DEMAND_RESPONSE_PROGRAM = "DEMAND_RESPONSE_PROGRAM",
}
